"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Api = void 0;

var _http = _interopRequireDefault(require("./http"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * 
 * A lightweight wrapper around the {@link http} module.
 * Provides functions to make API requests with specified HTTP methods.
 *
 * The functions are as follows:
 * - `get(url, options)` sends a `'GET'` request
 * - `patch(url, body, options)` sends a `'PATCH'` request
 * - `post(url, body, options)` sends a `'POST'` request
 * - `put(url, body, options)` sends a `'PUT'` request
 * - `destroy(url, body, options)` sends a `'DELETE'` request
 * - `call(url, method, body, options)` sends a request with specified method
 *
 * Each function can be passed an `options` object, which will eventually be forwarded
 * to the [Fetch API](https://developer.mozilla.org/en-US/docs/Web/API/Fetch_API).
 * 
 * Each function returns a promise, which will either resolve with a response object
 * or reject with an {@link HTTPError}.
 *
 * @name api
 * @type Object
 * 
 * @example
 * 
 * function getUsers () {
 *   return api.get('/users', { credentials: 'include' })
 * }
 * 
 * getUsers()
 *    .then(res => console.log('The users are', res))
 *    .catch(err => console.log('An error occurred!', err))
 */
var Api =
/*#__PURE__*/
function () {
  function Api() {
    var defaults = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, Api);

    this.defaults = defaults;
  }

  _createClass(Api, [{
    key: "call",
    value: function call(url, method, body) {
      var opts = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      return (0, _http["default"])(url, _objectSpread({}, this.defaults, {}, opts, {
        body: body,
        method: method
      }));
    }
  }, {
    key: "get",
    value: function get(url) {
      var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var body = null;
      return this.call(url, 'GET', body, opts);
    }
  }, {
    key: "patch",
    value: function patch(url, body) {
      var opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      return this.call(url, 'PATCH', body, opts);
    }
  }, {
    key: "post",
    value: function post(url, body) {
      var opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      return this.call(url, 'POST', body, opts);
    }
  }, {
    key: "put",
    value: function put(url, body) {
      var opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      return this.call(url, 'PUT', body, opts);
    }
  }, {
    key: "destroy",
    value: function destroy(url, body) {
      var opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      return this.call(url, 'DELETE', body, opts);
    }
  }]);

  return Api;
}(); // Exports a single instance of the Api class


exports.Api = Api;

var _default = new Api();

exports["default"] = _default;